/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddCartItemRequestItem } from './AddCartItemRequestItem';
import {
    AddCartItemRequestItemFromJSON,
    AddCartItemRequestItemFromJSONTyped,
    AddCartItemRequestItemToJSON,
} from './AddCartItemRequestItem';

/**
 * 
 * @export
 * @interface AddCartItemRequest
 */
export interface AddCartItemRequest {
    /**
     * 
     * @type {AddCartItemRequestItem}
     * @memberof AddCartItemRequest
     */
    item: AddCartItemRequestItem;
}

/**
 * Check if a given object implements the AddCartItemRequest interface.
 */
export function instanceOfAddCartItemRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "item" in value;

    return isInstance;
}

export function AddCartItemRequestFromJSON(json: any): AddCartItemRequest {
    return AddCartItemRequestFromJSONTyped(json, false);
}

export function AddCartItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCartItemRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'item': AddCartItemRequestItemFromJSON(json['item']),
    };
}

export function AddCartItemRequestToJSON(value?: AddCartItemRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item': AddCartItemRequestItemToJSON(value.item),
    };
}

